import DepositOnlineMoneyGateResults from '@features/deposit/screens/money-gate/zone/tj/DepositOnlineMoneyGateResults';
import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';

const DepositOnlineMoneyGate = () => {
  const { id } = useParams();

  if (!id) return null;

  return (
    <Fragment>
      <DepositOnlineMoneyGateResults orderId={id}/>
    </Fragment>
  );

};

export default DepositOnlineMoneyGate;